import React, { useEffect } from 'react'
import Layout from '../components/Layout'
import "../stylings/aboutSchool.css"
import { useDispatch } from 'react-redux';
import { hideLoading, showLoading } from '../redux store/loader';

const AboutSchool = () => {

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(showLoading());
        setTimeout(() => {
            dispatch(hideLoading())
        }, [1700])
    }, [])

    return (
        <Layout>
            <div className="about-school container">
                <div className="about-school-wrapper">
                    <div className="about-school-header">
                        <h3><span className='word-leader'>about</span> school</h3>
                        <div className="seprator-line-wrapper">
                            <span className="seprator-one"></span>
                            <span className="seprator-two"></span>
                        </div>
                    </div>
                    <div className="sub-heading">
                        <h5>welcome to Way, Truth and Life Foundation School!</h5>
                    </div>
                    <div className="description">
                        <p>
                            At <span>Way, Truth and Life Foundation School</span>, we believe in nurturing young minds to their fullest potential, fostering a love for learning, and providing a dynamic environment where students can thrive academically, socially, and emotionally. Our commitment to excellence in education is reflected in our comprehensive curriculum, dedicated faculty, and vibrant school community.
                        </p>
                    </div>
                    <div className="sub-heading">
                        <h5>Mission Statement:</h5>
                    </div>
                    <div className="description">
                        <p>
                           A Christian school that aims to contribute by preparing individuals in Godly Wisdom, Character, Values and Commitment to Academic Excellence for a better Society and Nation.
                        </p>
                    </div>
                    <div className="sub-heading">
                        <h5>Vision Statement:</h5>
                    </div>
                    <div className="description">
                        <p>
                          Way, Truth and Life Foundation School aims to be a quality Educational Institute, enabling a child to face the world, Mentally, Physically, Spiritually, Academically, Socially, Responsibly, Morally and Confidently. To be blessed and be blessing to the society in every possible way.
                        </p>
                    </div>
                    <div className="sub-heading">
                        <h5>Academic Excellence:</h5>
                    </div>
                    <div className="description">
                        <p>
                            Our curriculum is designed to inspire curiosity, critical thinking, and creativity. We offer a well-rounded education that encompasses core subjects such as Mathematics, Science, Language Arts, Social Studies as well as enrichment programs including Art, Music, Physical Education, and Technology. With a focus on personalized learning, we cater to the diverse needs and learning styles of every student, ensuring that each individual receives the support and resources they need to succeed.
                        </p>
                        <p>
                            At <span>Way, Truth and Life Foundation School</span>, we recognize the importance of preparing students for the challenges of the 21st century. That's why we integrate technology into the learning process, equipping students with essential digital skills and empowering them to adapt to an ever-changing world. Through project-based learning, collaborative activities, and real-world applications, students develop the critical skills of communication, collaboration, problem-solving, and creativity that are essential for success in today's global society.
                        </p>
                    </div>
                    <div className="sub-heading">
                        <h5>Dedicated Faculty:</h5>
                    </div>
                    <div className="description">
                        <p>
                            Our faculty members are passionate educators who are dedicated to the success and well-being of every student. With their expertise, enthusiasm, and commitment to excellence, they create engaging and supportive learning environments where students feel valued, challenged, and inspired to reach their full potential. Our teachers foster a culture of respect, empathy, and inclusivity, promoting positive relationships and a sense of belonging within the school community.
                        </p>
                    </div>
                    <div className="sub-heading">
                        <h5>Holistic Development:</h5>
                    </div>
                    <div className="description">
                        <p>
                            At <span>Way, Truth and Life Foundation School</span>, we believe in nurturing the whole child - academically, socially, emotionally, and morally. In addition to our rigorous academic program, we offer a variety of extracurricular activities, clubs, and sports programs that provide students with opportunities for personal growth, leadership development, and community engagement. Whether it's participating in a school play, joining a robotics team, or volunteering for a local charity, students are encouraged to explore their interests, develop their talents, and make meaningful contributions to society.
                        </p>
                    </div>
                    <div className="sub-heading">
                        <h5>Supportive Community:</h5>
                    </div>
                    <div className="description">
                        <p>
                            Our school community is built on a foundation of collaboration, respect, and mutual support. We believe that strong partnerships between students, parents, teachers, and staff are essential for student success. Through open communication, parent involvement, and community events, we foster strong connections and create a supportive network that empowers students to thrive academically and socially.
                        </p>
                    </div>
                    <div className="sub-heading">
                        <h5>Preparing for the Future:</h5>
                    </div>
                    <div className="description">
                        <p>
                            At <span>Way, Truth and Life Foundation School</span>, we are committed to preparing students not only for success in their academic pursuits but also for success in life. We instill in our students the values of integrity, responsibility, resilience, and empathy, preparing them to be compassionate and ethical leaders who make positive contributions to their communities. Whether they pursue higher education, enter the workforce, or pursue other pathways, our graduates are well-equipped with the knowledge, skills, and character traits needed to excel in whatever they choose to pursue.
                        </p>
                        <p>
                            In conclusion, <span>Way, Truth and Life Foundation School</span> is more than just a place of learning – it's a vibrant and inclusive community where students are empowered to discover their passions, unlock their potential, and become lifelong learners. We invite you to join us on this exciting journey of growth, discovery, and achievement.
                        </p>
                        <p>Welcome to <span>Way, Truth and Life Foundation School</span> - where every child has the opportunity to shine!</p>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default AboutSchool
